import { CountryCode } from 'shared/constants/countries';
import { GST_TAX_COUNTRY_CODES } from 'shared/constants/taxes';

import { useRegion } from '@/hooks/useRegion';

export const useIsGstTaxRegion = () => {
    const userRegion = useRegion();
    const isGstTaxRegion = GST_TAX_COUNTRY_CODES.includes(
        userRegion?.code as CountryCode,
    );

    return {
        isGstTaxRegion,
    };
};
